module.exports = __webpack_public_path__ + "img/pattern.4c2bf8bc.png";